// 二段階認証画面
import React, { useCallback, useEffect, useState } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  TextField,
  Grid,
  useMediaQuery,
  Button,
  Link
} from '@material-ui/core';
// import "./LoginPage.css";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { useRecoilState } from 'recoil';
import { isLoggedIn, btnColor, mainBlueColor } from '../GlobalState';
import logo from '../assets/logo1.png';
import { getUserPermission } from '../apicalls/employeeMaster';
import LoadingComponent from '../components/LoadingComponent';
import { ROLE, PLAN, faqLink } from '../const/Const';
import { DASHBOARD } from '../components/topicPath/const/MenuTree';

export const MfaPage: React.FC = () => {
  const [buttonColor] = useRecoilState(btnColor);
  const [mainColor] = useRecoilState(mainBlueColor);
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      main: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#52555F'
      },
      container: {
        position: 'relative',
        border: '2px solid #007dff',
        padding: '40px',
        backgroundColor: '#f5f5f5',
        borderRadius: '5px'
      },
      wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      mailHelpLink: {
        margin: '20px',
        textAlign: 'center'
      },
      mfaHelpLink: {
        position: 'absolute',
        bottom: '-30px',
        right: '0px'
      },
      root: {
        '& .MuiTextField-root': {
          margin: theme.spacing(1),
          width: '25ch'
        }
      },
      input: {
        width: '100%',
        backgroundColor: '#FFFFFF'
      }
    })
  );

  const classes = useStyles();
  const matches2 = useMediaQuery('(min-width:900px)');
  const history = useHistory();
  const user = history.location.state as {
    id: number;
    email: string;
    role: number;
    planId: number;
    menu: string;
  };

  const [loginCode, setLoginCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = (newData: string) => setLoggedIn(newData);
  // ログイン状態
  const [isLogin, setIsLogin] = useState<boolean>();

  useEffect(() => {
    isLoginCheck();
  }, []);

  /**
   * ログインチェック
   */
  const isLoginCheck = useCallback(() => {
    // バックエンドのソースには「get_user_roles」と記載のあるエンドポイントへアクセス
    getUserPermission().then(data => {
      // 未ログイン状態の場合
      if (data === 'Not logged in!') {
        setIsLogin(false);
      } else {
        // エラーの場合
        if (typeof data === 'string') {
          setIsLogin(false);
          setErrorMessage(data);
        } else {
          // エラーの場合
          if (data.error) {
            setIsLogin(false);
            setErrorMessage(data.error);

            // ログイン状態の場合
          } else {
            const tree = data.accessible_menu_tree;
            // アクセス可能なメニューリストにダッシュボードがあればダッシュボードに遷移。なければ工事
            if (tree.includes(DASHBOARD.menuId)) {
              history.replace('/dashboard');
            } else {
              history.replace('/constructions', data.user_id);
            }
          }
        }
      }
    });
  }, []);

  const onSubmit = () => {
    axios
      .post(
        `/user/mfa`,
        {
          user_id: user.id,
          login_code: loginCode
        },
        {
          headers: {
            withCredentials: true
          }
        }
      )
      .then(function (response) {
        if (response.status == 200) {
          changeLoggedInData('');
          const tree = response.data.accessible_menu_tree;
          const userId = response.data.user_id;
          // アクセス可能なメニューリストにダッシュボードがあればダッシュボードに遷移。なければ工事
          if (tree.includes(DASHBOARD.menuId)) {
            history.replace('/dashboard');
          } else {
            history.replace('/constructions', userId);
          }
        } else if (response.data.error) {
          setErrorMessage(response.data.error);
        } else {
          setErrorMessage('問題が発生しました。もう一度実行してください。');
        }
      })
      .catch(err => {
        if (err.response.data) {
          if (err.response.data.error) {
            setErrorMessage(err.response.data.error);
          } else {
            setErrorMessage('問題が発生しました。もう一度実行してください。');
          }
        } else {
          setErrorMessage('問題が発生しました。もう一度実行してください。');
        }
      });
  };

  return (
    <>
      {isLogin === undefined ? (
        <>
          <LoadingComponent />
        </>
      ) : (
        <div className={classes.main}>
          <Grid item xs={matches2 ? 6 : 12}>
            <div className={classes.container}>
              <div className={classes.wrapper}>
                <img
                  style={{ width: 100, height: 60, objectFit: 'contain' }}
                  alt='logo'
                  src={logo}
                />
              </div>
              <div style={{ textAlign: 'center' }}>
                <h1 style={{ color: mainColor }}>二段階認証</h1>
                <p style={{ margin: 0 }}>登録されているメールアドレス</p>
                <p style={{ margin: 0 }}>
                  {' '}
                  <span style={{ color: mainColor }}>{user.email}</span>
                  にセキュリティコードを送信しました
                </p>
                <p style={{ margin: 0 }}>
                  受け取ったセキュリティコードを入力し送信してください
                </p>
              </div>
              <div style={{ marginTop: 30 }}>
                <TextField
                  className={classes.input}
                  id='outlined-mail'
                  label='確認コードを入力'
                  variant='outlined'
                  onChange={e => {
                    setLoginCode(e.target.value);
                  }}
                />
              </div>
              <div style={{ color: '#DE4839' }}>{errorMessage}</div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: 40
                }}
              >
                <div className={classes.wrapper}>
                  <Button
                    onClick={() => {
                      history.push('/');
                    }}
                    style={{
                      backgroundColor: buttonColor,
                      margin: '0 20px',
                      width: '150px'
                    }}
                    variant='contained'
                    color='primary'
                  >
                    キャンセル
                  </Button>
                  <Button
                    onClick={() => {
                      onSubmit();
                    }}
                    style={{
                      backgroundColor: '#007DFF',
                      margin: '0 20px',
                      width: '150px'
                    }}
                    variant='contained'
                    color='primary'
                  >
                    送信
                  </Button>
                </div>
              </div>
              <div className={classes.mailHelpLink}>
                <Link
                  href={faqLink.mfa_mail}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{
                    color: mainColor,
                    textDecoration: 'underline',
                    margin: '20px auto'
                  }}
                >
                  二段階認証のメールが届かない方はこちら
                </Link>
              </div>
              <div className={classes.mfaHelpLink}>
                <Link
                  href={faqLink.mfa}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: 'white', textDecoration: 'underline' }}
                >
                  ヘルプページ
                </Link>
              </div>
            </div>
          </Grid>
        </div>
      )}
    </>
  );
};
